import PromptSaveModal from '@/common/containers/Modals/PromptSaveModal/PromptSaveModal';

export default PromptSaveModal;
